import { axiosInstance } from '../../utils/axios';

export const getMenus = async () => {
  const response = await axiosInstance.get('api/v1/menu/menu/', {
    params: {
      per_page: 500,
    },
  });
  return response.data;
};

export const editMenus = async (data) => {
  const response = await axiosInstance.patch(`api/v1/menu/menu/${data.uuid}/`, data);
  return response.status;
};

export const deleteMenus = async (uuid) => {
  const response = await axiosInstance.delete(`api/v1/menu/menu/${uuid}/`);
  return response.status;
};

export const createMenus = async (data) => {
  const response = await axiosInstance.post('api/v1/menu/menu/', data);
  return response.status;
};

export const getMenusPermissions = async (per_page = 500) => {
  const response = await axiosInstance.get('api/v1/menu/menu-permissions/', {
    params: {
      per_page,
    },
  });
  return response.data;
};

export const updatePermissions = async (data) => {
  const response = await axiosInstance.patch(`api/v1/menu/menu-permissions/${data.uuid}/`, data);
  return response.status;
};

export const createPermissions = async (data) => {
  const response = await axiosInstance.post(`api/v1/menu/menu-permissions/`, data);
  return response.status;
};

export const getUserPermissions = async () => {
  const response = await axiosInstance.get('api/v1/menu/user-menu-permissions/');
  return response.data;
};
